import { useEffect, useMemo, useRef } from "react"
import { BeginnerPathPromo } from "@/entities/beginner-path"
import { useInfinitePosts } from "@/entities/post"
import { shouldOfferHomeTour, useTour } from "@/features/onboarding-tour"
import { PageTransition } from "@/shared/ui/page-transition"
import { SectionHeading } from "@/shared/ui/section-heading"
import { ContinueWatching } from "@/widgets/continue-watching"
import { FormatsRail } from "@/widgets/formats-rail"
import { HomeHeader } from "@/widgets/home-header"
import { PostsFeed } from "@/widgets/posts-feed"

export function PostsPage() {
	const tour = useTour()

	const {
		data,
		isLoading,
		isError,
		error,
		refetch,
		fetchNextPage,
		hasNextPage,
		isFetchingNextPage,
	} = useInfinitePosts({ isActive: true, sortBy: "newest" })
	const posts = useMemo(() => data?.pages.flat() ?? [], [data])

	const tourStartRef = useRef(tour.start)
	tourStartRef.current = tour.start

	useEffect(() => {
		if (!shouldOfferHomeTour()) return
		const timer = window.setTimeout(() => tourStartRef.current(), 600)
		return () => window.clearTimeout(timer)
	}, [])

	return (
		<PageTransition>
			<div className="relative isolate -mt-[var(--app-body-padding-top)] pt-[var(--app-body-padding-top)]">
				<div
					aria-hidden
					className="pointer-events-none absolute inset-x-0 top-0 -z-10 h-[24rem] bg-[radial-gradient(120%_70%_at_50%_0%,color-mix(in_oklab,var(--color-primary)_28%,transparent),transparent_70%)]"
				/>
				<HomeHeader onHelp={tour.start} />
				<div className="container mx-auto max-w-3xl px-3 pt-3 sm:px-4">
					<BeginnerPathPromo />
				</div>
			</div>

			<div className="container mx-auto flex max-w-3xl flex-col gap-10 px-3 pt-10 pb-6 sm:px-4 lg:pb-8">
				<FormatsRail />
				<ContinueWatching />

				<section>
					<SectionHeading title="Все материалы" />
					<PostsFeed
						posts={posts}
						isLoading={isLoading}
						isError={isError}
						error={error}
						onRetry={() => void refetch()}
						hasNextPage={hasNextPage}
						isFetchingNextPage={isFetchingNextPage}
						onLoadMore={() => fetchNextPage()}
						emptyMessage="Пока нет публикаций"
					/>
				</section>
			</div>
		</PageTransition>
	)
}
